import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-ms-print-pass-instructions",
	templateUrl: "./ms-print-pass-instructions.component.html",
	styleUrls: ["./ms-print-pass-instructions.component.css"],
})
export class MsPrintPassInstructionsComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.PassImageB64 = this.dialogConfig.data.PassImageB64;
	}

	/////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////

	PassImageB64: string = "";

	/////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////////

	onPrint() {
		var htmlStr: string = "";

		htmlStr +=
			`
      <!DOCTYPE html>
      <html lang="en" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:v="urn:schemas-microsoft-com:vml">
        <head>
        <title></title>
        <meta charset="utf-8">
          <meta content="width=device-width,initial-scale=1" name="viewport">
        </head>
        
        <body style="width: 384px; Height: 216px;">
          <div style="width: 350px; height: 196.875px; background-color: white;">
            <img style="width: 100%; Height: 100%; margin-top: 5px; margin-left: 23px;" src="` +
			this.PassImageB64 +
			`">
          </div>
        </body>
      </html>
    `;

		var PrintPage = window.open();
		PrintPage.document.open();
		PrintPage.document.write(htmlStr);
		PrintPage.document.close();
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////////////////////////
}
